import React from 'react'

const EmptyChatRoom = () => {
  return (
        <div className="nk-chat-body profile-shown pe-0">
            
            <div className="nk-chat-panel" data-simplebar>

            </div>

            {/* <div className="nk-chat-editor">
                <div className="nk-chat-editor-upload  ml-n1">
                    <a href="#" className="btn btn-sm btn-icon btn-trigger text-primary toggle-opt" data-target="chat-upload"><em className="icon ni ni-plus-circle-fill"></em></a>
                    <div className="chat-upload-option" data-content="chat-upload">
                        <ul className="">
                            <li><a href="#"><em className="icon ni ni-img-fill"></em></a></li>
                            <li><a href="#"><em className="icon ni ni-camera-fill"></em></a></li>
                            <li><a href="#"><em className="icon ni ni-mic"></em></a></li>
                            <li><a href="#"><em className="icon ni ni-grid-sq"></em></a></li>
                        </ul>
                    </div>
                </div>
                <div className="nk-chat-editor-form">
                    <div className="form-control-wrap">
                        <textarea className="form-control form-control-simple no-resize" rows="1" id="default-textarea" placeholder="Type your message..."></textarea>
                    </div>
                </div>
                <ul className="nk-chat-editor-tools g-2">
                    <li>
                        <a href="#" className="btn btn-sm btn-icon btn-trigger text-primary"><em className="icon ni ni-happyf-fill"></em></a>
                    </li>
                    <li>
                        <button className="btn btn-round btn-primary btn-icon"><em className="icon ni ni-send-alt"></em></button>
                    </li>
                </ul>
            </div> */}
        </div>
    )
}

export default EmptyChatRoom
